import React from 'react';
import { Route, Switch } from 'react-router-dom';

import List from './Domains/List';
import Detail from './Domains/Detail';

function Domains() {
  return (
    <Switch>
      <Route exact path="/domains" component={List} />
      <Route path="/domains/:domain" component={Detail} />
    </Switch>
  );
}

export default Domains;
